import PropTypes from 'prop-types';
import VerticalMatchEventCardImpl from './vertical-match-event-card.js';
import MojitoCore from 'mojito/core';

/**
 * Vertical match event card. Full width card intended for feed style pages, showing the event
 * scoreboard on top of a background image and the event markets in a swipeable slider.
 *
 * @function VerticalMatchEventCard
 * @name view
 *
 * @memberof Mojito.Modules.EventCards.VerticalMatch
 */

/**
 * Vertical match event card prop types.
 *
 * @property {string} eventId - Id of event to show.
 * @property {string} [marketId] - Id of the promoted market. Shown as the first slide of the markets slider, followed by the event market lines. If omitted, only the event market lines are shown.
 * @property {string} [backgroundImageUrl] - Card photo layer image URL. If omitted, the sport image from the photoLayer.backgroundImages config is used.
 * @property {boolean} [shouldRequestData = true] - Flag indicating whether component should request event and market data from content. If false, then neither event nor markets will be requested, hence in order to present info corresponding data should be already available in a store.
 * @property {boolean} [showSkeleton = true] - True if data loading skeleton should be visible. It can be useful to hide skeleton if parent component already covers component with its of top level skeleton.
 * @property {boolean} [reportLoadingStatus = false] - Flag indicating if component should register itself to track on data loading and rendering status which ends up in reporting `Mojito.Core.Services.Performance.types.TIMELINE_RECORD_TYPES.PAGE_READY` metric once all visible components on the page are rendered and presenting data.
 * @property {object | Function} [elementRef] - A ref to the rendered element.
 *
 * @memberof Mojito.Modules.EventCards.VerticalMatch.view
 */
const propTypes = {
    eventId: PropTypes.string.isRequired,
    marketId: PropTypes.string,
    backgroundImageUrl: PropTypes.string,
    shouldRequestData: PropTypes.bool,
    showSkeleton: PropTypes.bool,
    reportLoadingStatus: PropTypes.bool,
    elementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

const defaultProps = {
    shouldRequestData: true,
    showSkeleton: true,
    reportLoadingStatus: false,
};

export default MojitoCore.Presentation.UIView(
    'VerticalMatchEventCard',
    VerticalMatchEventCardImpl,
    propTypes,
    defaultProps
);
